module.exports = "/images/sell-quick.png?7f2b78ac9367ea0348f18f7da2d3f88a";